import propTypes from 'prop-types';
import { inject, observer } from 'mobx-react';

import { SwitchGroups } from './SwitchGroups/SwitchGroups.jsx';
import { TableHeader } from './TableHeader/TableHeader.jsx';

const _ProductsTable = ({ uiStore }) => (
  <>
    {!uiStore.isMobile && <TableHeader />}
    <SwitchGroups />
  </>
);

_ProductsTable.propTypes = {
  uiStore: propTypes.shape({
    isMobile: propTypes.bool
  }).isRequired
};

export const ProductsTable = inject('uiStore')(observer(_ProductsTable));
